import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Modal from '../../shared/modals/modal.component';
import { removeAdjustment } from '../adjustmentsTab/store/actions';
import { isRemovingInProgressSelector } from '../adjustmentsTab/store/selectors';

import { requiredWhenPresent } from '../../shared/propTypes';

class DeleteAdjustmentModal extends PureComponent {
  static propTypes = {
    entityToRemove: requiredWhenPresent(['isVisible'], PropTypes.shape({
      description: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
      rowIndex: PropTypes.number.isRequired,
    })),
    hideModal: PropTypes.func.isRequired,
    removeAdjustment: PropTypes.func.isRequired,
    isVisible: PropTypes.bool,
    isRemovingInProgress: PropTypes.bool.isRequired,
  };

  removeAdjustment = () => {
    const { removeAdjustment, entityToRemove } = this.props;
    removeAdjustment(entityToRemove);
  };

  render() {
    const { hideModal, entityToRemove, isVisible, isRemovingInProgress } = this.props;

    return (
      <Modal
        title="Delete adjustment"
        closeAction={hideModal}
        dismissText="Cancel"
        dismissAction={hideModal}
        submitText="Yes"
        submitAction={this.removeAdjustment}
        isVisible={isVisible}
        isSubmitting={isRemovingInProgress}
      >
        {
          entityToRemove
            ? (
              <div>
                Deleting the following adjustment: <br/><br/>
                Description: {entityToRemove.description}<br/>
                Amount: {entityToRemove.amount}<br/><br/>
                Continue delete?
              </div>
            )
            : null
        }
      </Modal>
    );
  }
}

export default connect(state => ({
  isRemovingInProgress: isRemovingInProgressSelector(state),
}),
{
  removeAdjustment,
})(DeleteAdjustmentModal);
